
import { Har, SummaryMetrics, Entry, Page, ProcessedPageTiming } from '../types';

export const calculateSummaryMetrics = (harData: Har): SummaryMetrics => {
  const entries = harData.log.entries;
  const totalRequests = entries.length;
  
  let totalDataTransferred = 0;
  let totalResponseTime = 0;
  let errorCount = 0;
  const requestsByMethod: Record<string, number> = {};
  const contentTypes: Record<string, number> = {};
  const domains: Record<string, number> = {};

  entries.forEach(entry => {
    // Sum of actual bytes from network for response and request body size
    totalDataTransferred += (entry.response.bodySize > 0 ? entry.response.bodySize : 0);
    totalDataTransferred += (entry.request.bodySize > 0 ? entry.request.bodySize : 0);
    
    totalResponseTime += entry.time;

    if (entry.response.status >= 400) {
      errorCount++;
    }

    requestsByMethod[entry.request.method] = (requestsByMethod[entry.request.method] || 0) + 1;

    const mimeType = entry.response.content.mimeType.split(';')[0].trim() || 'unknown'; // Get base MIME type
    contentTypes[mimeType] = (contentTypes[mimeType] || 0) + 1;

    try {
      const url = new URL(entry.request.url);
      const domain = url.hostname;
      domains[domain] = (domains[domain] || 0) + 1;
    } catch (e) {
      // Invalid URL, skip domain counting for this entry
    }
  });

  const averageResponseTime = totalRequests > 0 ? totalResponseTime / totalRequests : 0;

  let totalLoadTime : number | undefined = undefined;
  if (harData.log.pages && harData.log.pages.length > 0) {
    // Use the onLoad timing from the first page if available
    const firstPage = harData.log.pages[0];
    if (firstPage.pageTimings && typeof firstPage.pageTimings.onLoad === 'number' && firstPage.pageTimings.onLoad > 0) {
      totalLoadTime = firstPage.pageTimings.onLoad;
    } else if (entries.length > 0) { // Fallback: sum of all request times if onLoad is not available
        // This is not a true page load time but can be an approximation if page timings are missing
        // A better fallback might be the time from start of first request to end of last request
        const firstEntryStart = new Date(entries[0].startedDateTime).getTime();
        const lastEntry = entries[entries.length - 1];
        const lastEntryEnd = new Date(lastEntry.startedDateTime).getTime() + lastEntry.time;
        totalLoadTime = lastEntryEnd - firstEntryStart;
    }
  }


  return {
    totalRequests,
    totalDataTransferred,
    averageResponseTime,
    errorCount,
    requestsByMethod,
    contentTypes,
    domains,
    totalLoadTime
  };
};

export const getPageTimings = (pages?: Page[]): ProcessedPageTiming[] | null => {
  if (!pages || pages.length === 0) return null;
  return pages.map(page => ({
    id: page.id,
    title: page.title,
    onContentLoad: page.pageTimings.onContentLoad !== undefined && page.pageTimings.onContentLoad > 0 ? page.pageTimings.onContentLoad : undefined,
    onLoad: page.pageTimings.onLoad !== undefined && page.pageTimings.onLoad > 0 ? page.pageTimings.onLoad : undefined,
  }));
};
